import React from 'react';
import Heading2 from '@Components/heading_2/view';
import Heading3 from '@Components/heading_3/view';

import s from '../styles/DetailContent.module.css';

const Knowledge18 = () => {
    return (
        <div className={s.wrapper}>
            <section className={s.section}>
                <Heading2 title='ゴルフ会員権購入後、入会の際に推薦状は必要か' fontWeight={700} />
                <p>
                    ゴルフ場で会員としてプレーするには、ゴルフ会員権を購入するだけではなく、各ゴルフ場で定められた入会条件を満たさなければなりません。
                    <br />
                    その中でも特に悩みの種となりやすいのが、推薦状の準備です。ゴルフ場によっては、「会員からの紹介、保証、推薦がなければ会員になれない」と会員規約で定められている場合があります。しかし、ゴルフ場の会員であれば誰でも推薦人になれるというわけでもありません。
                    <br />
                    推薦人として名を連ねるにあたって、在籍年数や会員種別などの条件を定めているゴルフ場もあり、原則として入会者との面識があり、親しい間柄であることが前提条件となっています。
                    <br />
                    推薦状が必要であるかはゴルフ場にもよりますので、会員権を購入する前によく確認しておきましょう。
                    <br />
                    <br />
                    会員として認められるためには、推薦状の用意以外にも、ゴルフ場で定めた入会条件をクリアしなくてはなりません。
                    <br />
                    「満○歳以上」「学生不可」など、年齢制限を設けていたり、日本国籍の人のみを対象としているゴルフ場もあります。入会にあたって、他のクラブの在籍証明書が必要な場合もあり、ゴルフ場によって入会基準は様々です。
                    <br />
                    面接や同伴プレーで人柄やマナーをチェックされることもあるため、入会条件と手続の流れについて、ひととおり調べておくとよいでしょう。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='ゴルフ会員権の推薦状の文例' fontWeight={700} />
                <p>
                    推薦状の文例については、以下のとおりです。
                    <br />
                    <br />
                    <strong>
                        <u>【推薦状の文例】</u>
                    </strong>
                    <br />
                    ○○氏とは○○大学時代より３０年来の友人です。
                    <br />
                    ゴルフも何度か一緒にプレーしたことがあり、マナー・エチケットともに申し分ない人物です。今般、貴クラブ入会の話を聞き、今後一緒にプレー出来ることを楽しみにしております。理事長他クラブ関係者皆様のご高配を賜りたくお願い申し上げます。
                    <br />
                    <br />
                    ゴルフ場によって推薦状のフォーマットが異なるため、上記はあくまでも参考としてお考えください。本人との関係性、付き合いの度合い、ゴルフプレーの様子などを中心に記述すると良いでしょう。
                    <br />
                    推薦状の記入方法についてご不明点などございましたら、当社までお気軽にお問合せください。豊富な実績・経験に基づき、推薦状としてふさわしい文章に仕上がるようアドバイスさせていただきます。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='推薦状をもらった際の御礼とは' fontWeight={700} />
                <p>
                    入会希望者を推薦する際には、推薦状や印鑑証明書等を用意したり、面接に同伴する等、推薦人にもそれなりの手間がかかります。推薦人より推薦状をいただい場合は推薦人に対しては御礼をお送りすることをおすすめします。
                </p>

                <Heading3 title='御礼状の文例' />
                <p>
                    推薦していただいた件について御礼状を用意する場合、以下のような文章を用意するとよいでしょう。
                    <br />
                    <br />
                    <strong>
                        <u>【御礼状の文例】</u>
                    </strong>
                    <br />
                    この度は○○カントリークラブご入会に関する推薦者の件、お引き受けいただきありがとうございました。書類提出も無事完了し、入会決定は○月○日頃になる予定です。晴れて入会できた際は是非プレーをご一緒させていただけましたら幸いです。何卒よろしくお願いいたします。まずは御礼かたがたご報告申し上げます。
                    <br />
                    <br />
                    上記はあくまで文章の一例ですので、推薦人との関係性など、相手によって文章を変更しましょう。
                </p>

                <Heading3 title='推薦人への謝礼の内容' />
                <p>
                    推薦人に対しては、相応の謝礼を用意しておきましょう。
                    <br />
                    推薦人が親しい知人であるなら食事をご馳走したり、使用しているゴルフボールや食べ物、お酒、商品券を贈ったりする等、相手との付き合いの度合いを踏まえて謝礼を選択しても良いでしょう。
                    <br />
                    謝礼の内容については、ゴルフ場によってしきたりが存在する場合があります。推薦人に失礼がないよう、会員やゴルフ会員権取引業者等に詳しい内容を確認することをおすすめします。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='ゴルフ会員権のお悩みは「住地ゴルフ」にお任せください' fontWeight={700} />
                <p>
                    ゴルフ会員権を取得するためには、条件を満たした推薦人からの推薦状が必要となる場合があります。
                    <br />
                    知人から紹介してもらう等、面識のない相手に推薦人になってもらう場合もあります。「推薦人になったものの、推薦状の書き方が分からない」「御礼状の文面で悩んでいる」等、お困りのことがあれば、まずは「住地ゴルフ」にご相談ください。
                    <br />
                    身近に推薦者が見つからない場合の対処法は
                    <a href='/knowledge/52'>推薦者がいない場合の入会方法</a>
                    で、推薦状を書いてくれた推薦人以外の紹介者への一般的なお礼のマナーは
                    <a href='/knowledge/54'>紹介者へのお礼マナー</a>
                    でご紹介しています。
                    <br />
                    ゴルフ会員権の仕組や手続に関しては複雑な部分が多く存在し、理解が難しいと感じる方も多くいらっしゃいます。推薦状以外についても、ゴルフ会員権で分からないことがあればご遠慮なくお問合せください。
                    <br />
                    そもそもゴルフ会員権とは何かという基礎知識は<a href='/knowledge/8'>こちら</a>をご覧ください。
                </p>
            </section>
        </div>
    );
};

export default Knowledge18;
